import { Epic, ofType } from 'redux-observable';
import { RootAction, RootState, Services } from 'typesafe-actions';
import { of } from 'rxjs';
import { catchError, switchMap, map } from 'rxjs/operators';
import { UserList } from '@amzn/coral_com-amazon-passportusermanagementservice';
import { getUsersForLogisticsParty } from '../../../actions/userManagementActions';
import {
  GET_USERS_FOR_LOGISTICS_PARTY_FAILURE,
  GET_USERS_FOR_LOGISTICS_PARTY_REQUEST,
} from '../../../actions/userManagementActions/actionTypes';
import { pageRoutes } from '../../../routes';
import {
  DEFAULT_NOTIFICATION_CLOSE_TIMEOUT,
  DEFAULT_ROUTE_CHANGE_TIMEOUT,
  NotificationTypeEnum,
} from '../../../actions/ui/types';
import { addNotification, pushRoute } from '../../../actions/ui';
import { UNAUTHORIZED_ERROR_MSG_FRAGMENT } from '../../../constants/error';
import isSiteExternal from '../../../utils/isSiteExternal';

export const getUsersForLogisticsPartyEpic: Epic<
  RootAction,
  RootAction,
  RootState,
  Services
> = (action$, state$, { api }) =>
  action$.pipe(
    ofType(GET_USERS_FOR_LOGISTICS_PARTY_REQUEST),
    switchMap((action) => {
      const { history = null, logisticsPartyId } = action.payload;

      return api.userManagementServices
        .getUsersForLogisticsParty({ logisticsPartyId })
        .pipe(
          map((response) =>
            getUsersForLogisticsParty.success(response.userList as UserList)
          ),
          catchError((err) => {
            const errorActions: Array<any> = [
              getUsersForLogisticsParty.failure(err),
            ];

            // TODO: temporarily kept this error msg fragment to compute if user dont have permission for GetUsersForLogisticsParty
            // Ideally 403 status should be used for unauthorized but currently 500 status is being sent by API
            const isUnauthorized = err?.receivedException?.message?.includes(
              UNAUTHORIZED_ERROR_MSG_FRAGMENT
            );
            if (history && isSiteExternal()) {
              errorActions.push(
                pushRoute(
                  history,
                  pageRoutes.PROFILE_PAGE,
                  DEFAULT_ROUTE_CHANGE_TIMEOUT
                )
              );
            }

            errorActions.push(
              addNotification({
                type: NotificationTypeEnum.ERROR,
                action: GET_USERS_FOR_LOGISTICS_PARTY_FAILURE,
                body: isUnauthorized
                  ? 'get_users_logistics_party_notifications.unauthorized'
                  : 'get_users_logistics_party_notifications.failure',
                timeout: DEFAULT_NOTIFICATION_CLOSE_TIMEOUT,
              })
            );
            return of(...errorActions);
          })
        );
    })
  );

export default getUsersForLogisticsPartyEpic;
